export default {
  getReleases(state) {
    return state.releases
  },
  getReleasesSettings(state) {
    return state.releasesSettings
  },
  getFeatures(state) {
    return state.features
  },
  getFeatureDetail(state) {
    return state.featureDetail
  },
}